import MediaSlider from "./MediaSlider.js";

export default function MediaGallery(container) {
    const popupElementId = container.getAttribute("data-popup-id");
    const popupElement = document.getElementById(popupElementId);
    const popupSliderElement = popupElement.querySelector(".js-media-slider");
    const increaseButton = container.querySelector(".js-media-gallery-increase-button");
    const popupCloseButton = popupElement.querySelector(".js-media-gallery-popup-close-button");

    const mediaGallerySlider = new MediaSlider(container);
    const mediaGalleryPopupSlider = new MediaSlider(popupSliderElement);

    mediaGallerySlider.setLinkedSlider(mediaGalleryPopupSlider);
    mediaGalleryPopupSlider.setLinkedSlider(mediaGallerySlider);

    increaseButton.addEventListener("click", function() {
        popupElement.classList.add("is-active");
        mediaGalleryPopupSlider.updateSize();
    });

    popupCloseButton.addEventListener("click", function() {
        popupElement.classList.remove("is-active");
    });
}